import React from 'react';
import CardHeader from './CardHeader';
import Chart from './Chart';


const OverviewChart = ({ incomes, outcomes }) => {
  return (
    <div className="card shadow">
      <CardHeader />
      <div className="card-body">
        <Chart incomes={incomes} outcomes={outcomes} />
      </div>
    </div>
  );
}

export default OverviewChart;


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/OverviewChart/index.js